import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  ADDRESS_COUNTRY,
  COMPANY_NAME,
  PROFIT,
  PURCHASE_VOLUME,
  SECTOR,
  SIZE_MAX,
  STOCK_TICKER,
  SUPPLIERS_EXPENSES,
  WEBSITE,
} from 'constants/formFields';
import { DEFAULT_OPTION } from 'constants/general';
import { updateAnalysisSchema } from 'utils/validators';

import type { TUpdateAnalysisSchema } from 'utils/validators';
import type IUpdateItemForm from '../interfaces/IUpdateItemForm';

const useUpdateItemForm = ({ isPageLoading }: IUpdateItemForm) => {
  const {
    control,
    handleSubmit,
    formState: { isDirty, isLoading, errors },
    reset,
    setError,
    getValues,
    watch,
    setValue,
    resetField,
  } = useForm<TUpdateAnalysisSchema>({
    mode: 'onSubmit',
    resolver: yupResolver(updateAnalysisSchema),
    defaultValues: {
      [COMPANY_NAME]: DEFAULT_OPTION,
      [STOCK_TICKER]: [],
      [WEBSITE]: '',
      [SECTOR]: [],
      [SIZE_MAX]: '',
      [SUPPLIERS_EXPENSES]: '',
      [ADDRESS_COUNTRY]: DEFAULT_OPTION,
      [PURCHASE_VOLUME]: '',
      [PROFIT]: '',
    },
  });

  useEffect(() => {
    if (!isPageLoading) {
      reset();
    }
  }, [reset, isPageLoading]);

  const fieldsName = Object.keys(getValues());

  return {
    control,
    handleSubmit,
    isDirty,
    reset,
    isLoading,
    setError,
    fieldsName,
    watch,
    setValue,
    resetField,
    errors,
  };
};

export default useUpdateItemForm;
